import { Trophy } from 'lucide-react';

// Small trophy pill shown next to a tipster's name on leaderboards.
// `titles` is an array of {competition_id, title, sport} from the backend.
// Sport colours mirror the leaderboard palette.
const SPORT_COLOURS = {
  AFL: '#E00000',
  NRL: '#007A33',
  EPL: '#37003C',
  WC: '#4338CA',
};

export default function TrophyRibbon({ titles, size = 'sm' }) {
  if (!titles || titles.length === 0) return null;

  const tooltip = titles.map(t => `${t.title} champion`).join(' • ');
  // Colour the ribbon by the first title's sport (or gold if unknown).
  const colour = SPORT_COLOURS[titles[0]?.sport] || '#B8860B';
  const iconClass = size === 'lg' ? 'w-3.5 h-3.5' : 'w-3 h-3';

  return (
    <span
      className="inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white shadow-sm"
      style={{ backgroundColor: colour }}
      title={tooltip}
      aria-label={tooltip}
      data-testid="trophy-ribbon"
    >
      <Trophy className={iconClass} strokeWidth={2.5} fill="#FFD700" stroke="#FFF8DC" />
      <span>{titles.length > 1 ? `x${titles.length}` : '1'}</span>
    </span>
  );
}
